'use client';

import { type FC, type HTMLAttributes, useEffect } from 'react';

import { registerSceneCanvas } from './scene-canvas-element';

// Cast the custom-element tag to a typed component so JSX accepts the `scene`
// prop without augmenting the global JSX.IntrinsicElements namespace.
const SceneTag = 'scene-canvas' as unknown as FC<
	HTMLAttributes<HTMLElement> & { scene: string }
>;

interface SceneCanvasProps {
	scene: string;
	className?: string;
}

/**
 * Thin React wrapper around the <scene-canvas> Web Component.
 * Registers the element on mount (client-only). The element upgrades itself
 * once defined, handles the cross-fade when its `scene` attribute changes, and
 * pauses off-screen. The wrapper is always dark so SSR and the first client
 * paint stay visually identical (no flash).
 */
export function SceneCanvas({ scene, className }: SceneCanvasProps) {
	useEffect(() => {
		registerSceneCanvas();
	}, []);

	return (
		<div className={className} style={{ background: '#0a0a0b' }}>
			<SceneTag
				scene={scene}
				style={{ display: 'block', width: '100%', height: '100%' }}
			/>
		</div>
	);
}
